import type { DifferentProps } from '@/components/claims/Different';
import type { HeroProps } from '@/components/claims/Hero';
import type { HowItWorksProps } from '@/components/claims/HowItWorks';
import type { ReviewsProps } from '@/components/claims/Reviews';
import type { StatsProps } from '@/components/claims/Stats';
import { sharedConfig } from '@/pageConfig/shared';
import type { BasePageConfig } from '../../BasePageConfig';
import { config as enUsConfig } from '../us/en';

export interface Config extends BasePageConfig {
  hero: HeroProps;
  stats: StatsProps;
  howItWorks: HowItWorksProps;
  reviews: ReviewsProps;
  different: DifferentProps;
}

export const config: Config = {
  layout: { ...sharedConfig['en-GB'].layout },
  seo: {
    ...enUsConfig.seo,
    description:
      'Submit and manage Lemonade UK insurance claims easily through the Lemonade app. Our tech-driven process offers fast resolutions with dedicated team support.',
  },
  hero: { ...enUsConfig.hero },
  howItWorks: { ...enUsConfig.howItWorks },
  stats: { ...enUsConfig.stats },
  reviews: { ...enUsConfig.reviews, showVideo: false },
  different: { ...enUsConfig.different, title: 'Paying Claims. Doing Good' },
};
